module.exports = __webpack_public_path__ + "components/country-flag/static/pk-40849094ce754431a57913e1be48c30a.svg";